import React, { useEffect, useRef, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { BurgerMenuIcon, MoreVerticalIcon } from '../../icons/Icons'
import {initialIframeSetting} from '../../app/config'
import classNames from 'classnames'
import {quickReplyFilledActiveStyles} from '../message/Reply/QuickReply/quickReplyStyles'
import { browserType, keyType, persistentMenuItemType } from '../../constants/string'
import { userActionEvents } from '../../constants/userActionEvents'

import classes from './styles.module.scss'
import {paperStyles} from './config'
import {
  generatePostBackObjectWithType,
  sendUserEventToParent
} from '../../actions/static'
import { focusTrapCreator } from '../../helper/focusTrapCreator'
import { detectBrowserType } from '../../helper/detectBrowserType'

const PersistentMenu = props => {
  const { isPanoramaPost, anchorMenu, setAnchorMenu, setIsLoadingIframeData, persistentMenuButtonRef, updateDisablingButtonsByPersistentMenuUse, textMessageRef } = props
  const menuItemRefs = useRef([])
  const persistentMenuContainerRef = useRef(null)
  const browserName = detectBrowserType()
  const hasFocusOutline = browserName === browserType.SAFARI
  const isExpandedMenu = !!anchorMenu
  const { t } = useTranslation()

  useEffect(() => {
    if (!anchorMenu) {
      props.setClickableChat(true)
      return
    }
    menuItemRefs.current[0].focus()

    props.setClickableChat(false)
  }, [anchorMenu])

  useEffect(() => {
    if (props.isUserIdle) {
      setAnchorMenu(null)
    }
  }, [props.isUserIdle])

  const toggleMenu = e => {
    if (anchorMenu) {
      setAnchorMenu(null)
      return
    } else {
      sendUserEventToParent(userActionEvents.MENU_OPEN)
    }
    setAnchorMenu(e.currentTarget)
  }

  const itemAction = (item) => {
    setAnchorMenu(null)
    if(item.type === persistentMenuItemType.POSTBACK){
      props.setIframe(initialIframeSetting)
      disablingComponents()
    }
    props.postMessage({...generatePostBackObjectWithType(item, item.type), messageStyle: isPanoramaPost ? quickReplyFilledActiveStyles : null})
    item.isRtl = false
  }

  const linkEditorListener = url => {
    setIsLoadingIframeData(false)
    setAnchorMenu(null)
    props.setIframe(initialIframeSetting)
    setTimeout(() => {
      props.setIframe({
        iframeSrc: url,
        isIframeOpen: true,
        questionnaireName: props.iframeSettings.questionnaireName
      })
    }, 0)
  }

  const handleWebUrlClick = (item) => item.enableMessengerExtensions ? linkEditorListener(item.url) : setAnchorMenu(null)

  const clickHandler = (item) => {
    if (item.type === 'web_url') {
      handleWebUrlClick(item)
    } else {
      itemAction(item)
    }
  }

  const keyDownHandler = (e, item) => {
    const key = e.key.toLowerCase()
    switch (key) {
      case keyType.ENTER:
      case keyType.SPACE:
        clickHandler(item)
        break
      case keyType.ESCAPE:
        setAnchorMenu(null)
        persistentMenuButtonRef.current.focus()
        break
    }
  }

  const PersistentMenuItem = ({ item }) => {
    if (item.type === 'web_url') {
      return item.enableMessengerExtensions
        ? (<button>{item.title}</button>)
        : (
          <a href={item.url} target='_blank' rel='noopener noreferrer'>
            {item.title}
          </a>
        )
    } else {
      return <button>{item.title}</button>
    }
  }

  const disablingComponents = () => {
    updateDisablingButtonsByPersistentMenuUse()
    textMessageRef.current.resetRating()
    textMessageRef.current.resetDropdown()
  }

  return (
    <div className={classNames(
      classes.container,
      props.isCloseWidgetModalOpened ? classes.disabled : null
    )}>
      <button
        ref={persistentMenuButtonRef}
        aria-label={t('persistent_menu')}
        aria-controls='persistentMenu'
        aria-expanded={isExpandedMenu}
        data-test='menu'
        className={classNames(classes.menuIcon, hasFocusOutline && classes.focusLine)}
        id='menu-button'
        onClick={toggleMenu}
      >
        <BurgerMenuIcon />
      </button>
      {anchorMenu &&
        <div
          ref={persistentMenuContainerRef}
          className={classes.popper}
          onKeyDown={(e) => focusTrapCreator(e, persistentMenuContainerRef.current, true)}
        >
          <div
            className={classNames(classes.paper, classes.paperElevation)}
            style={paperStyles(anchorMenu)}
          >
            <ul
              data-test='menu-items'
              className={classes.menuList}
            >
              {props.persistentMenu?.callToActions && props.persistentMenu.callToActions.map((item, index) => (
                <li
                  className={classes.menuItem}
                  ref={el => menuItemRefs.current[index] = el}
                  key={index}
                  onClick={() => clickHandler(item)}
                  onKeyDown={(e) => keyDownHandler(e, item)}
                >
                  <PersistentMenuItem
                    data-test='persistent-menu-item'
                    item={item}
                  />
                </li>
              ))}
            </ul>
          </div>
        </div>}
    </div>
  )
}

export default PersistentMenu
